import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "../Login/login.css";
import { AWS_URL } from "../../Constant";

function Login() {
  const navigate = useNavigate();
  const [loginType, setLoginType] = useState("empid"); // empid, phone or scheme
  const [empid, setEmpid] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const onSubmitSuccess = (jwtToken) => {
    const cookieOptions = {
      expires: 30,
      sameSite: "Strict",
      ...(window.location.protocol === "https:" ? { secure: true } : {}),
    };
    Cookies.set("jwt_token", jwtToken, cookieOptions);
    sessionStorage.setItem("loginTime", String(Date.now()));
    navigate("/dashboard");
  };

  const onSubmitFailure = (msg) => {
    setShowError(true);
    setErrorMsg(msg || "Login failed. Please try again.");
  };

  // 🔹 Handle EMPID + password login
  const handleEmpidLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${AWS_URL}/login/empid`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ empid, password }),
      });
      const data = await res.json();
      if (res.ok) {
        onSubmitSuccess(data["access_token"]);
      } else {
        onSubmitFailure(data.msg);
      }
    } catch {
      onSubmitFailure("Network error");
    }
  };


// ✅ Send OTP to employee's phone
  const handleSendOtp = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${AWS_URL}/login/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ empid, phone }),
      });

      const data = await res.json();
      if (res.ok) {
        setOtpSent(true);
        setShowError(false);
      } else {
        onSubmitFailure(data.msg);
      }
    } catch {
      onSubmitFailure("Failed to send OTP");
    }
  };

//   // ✅ Verify OTP and login
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${AWS_URL}/login/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ empid, phone, otp }),
      });

      const data = await res.json();
if (res.ok) {
        onSubmitSuccess(data["access_token"]);
      } else {
        onSubmitFailure(data.msg);
      }
    } catch {
      onSubmitFailure("OTP verification failed");
    }
  };


  return (
    <div className="Login">
      <div className="login-form">
        <div className="title">Sign In</div>

        {/* Toggle between login types */}
        <div className="flex gap-3 mb-4">
          <button
            type="button"
            className={`p-2 rounded-lg ${
              loginType === "empid" ? "bg-sky-600 text-white" : "bg-gray-200"
            }`}
            onClick={() => {
              setLoginType("empid");
              setOtpSent(false);
              setShowError(false);
            }}
          >
            Manager Login
          </button>
          <button
            type="button"
            className={`p-2 rounded-lg ${
              loginType === "phone" ? "bg-sky-600 text-white" : "bg-gray-200"
            }`}
            onClick={() => {
              setLoginType("phone");
              setOtpSent(false);
              setShowError(false);
            }}
          >
            Executive Login
          </button>
          <button
            type="button"
            className={`p-2 rounded-lg ${
              loginType === "scheme" ? "bg-sky-600 text-white" : "bg-gray-200"
            }`}
            onClick={() => {
              setLoginType("scheme");
              setOtpSent(false);
              setShowError(false);
            }}
          >
            Login for Schemes
          </button>
        </div>

        {/* EMPID Login Form */}
        {loginType === "empid" && (
          <form onSubmit={handleEmpidLogin}>
            <div className="input-container">
              <label>EmpID</label>
              <input
                type="text"
                value={empid}
                onChange={(e) => setEmpid(e.target.value)}
                required
              />
            </div>
            <div className="input-container">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="button-container">
              <button
                type="submit"
                className="bg-sky-600 text-white rounded-lg p-1 w-24"
              >
                Sign In
              </button>
            </div>
          </form>
        )}

        {/* Phone + OTP Login Form */}

        {loginType === "phone" && (
          <form onSubmit={otpSent ? handleVerifyOtp : handleSendOtp}>
            {!otpSent ? (
              <>
                <div className="input-container">
                  <label>EmpID</label>
                  <input
                    type="text"
                    value={empid}
                    onChange={(e) => setEmpid(e.target.value)}
                    required
                  />
                </div>
                <div className="input-container">
                  <label>Phone</label>
                  <input
                    type="text"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </div>
              </>
            ) : (
              <div className="input-container">
                <label>Enter OTP</label>
                <input
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                />
              </div>
            )}

            <div className="button-container">
              <button
                type="submit"
                className="bg-sky-600 text-white rounded-lg p-1 w-28"
              >
                {otpSent ? "Verify OTP" : "Send OTP"}
              </button>
            </div>
          </form>
        )}

        {loginType === "scheme" && (
          <div className="button-container">
            <button
              type="button"
              className="bg-sky-600 text-white rounded-lg p-1 w-44"
              onClick={() => navigate("/customer/login")}
            >
              Continue to Scheme Login
            </button>
          </div>
        )}
      </div>

      {showError && (
        <p className="error-message text-rose-600 font-bold mt-2">{errorMsg}</p>
      )}
    </div>
  );
}

export default Login;
